(function(module) {
    'use strict';
    function RegisterConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('register', {
                url: '/register',
                data: {
                    pageTitle: 'REGISTER.PAGE_TITLE',
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl',
                    },
                    'content@register': {
                        templateUrl: '/js/authentication/register/register.html',
                        controller: 'RegisterCtrl as $ctrl',
                    },
                },
                bodyClass: 'page--register',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/register');

    }

    function RegisterCtrl(LoopBackAuth, Store, User, $state) {
        this.$onInit = () => {
            if (User.isAuthenticated()) {
                Store.setCurrentSubAccountId(null);

                LoopBackAuth.clearUser();
                LoopBackAuth.clearStorage();
            }
        };

        this.register = (user) => {
            const data = {
                ...user,
                email: user.email.toLowerCase(),
            }
            User
                .trial(data)
                .$promise
                .then(() => {
                    $state.go('verify-email');
                })
                .catch((response) => {
                    console.log('response', response);
                    this.api = {
                        error: true,
                    };
                });
        };

    }

    module
        .config(RegisterConfig)
        .controller('RegisterCtrl', RegisterCtrl);

})(angular.module('rocket.components'));
